import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { testAuthDirectly } from '../../utils/debugAuth';
import axios from 'axios';
import './admin.css';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [directMode, setDirectMode] = useState(false);
  const [useProxy, setUseProxy] = useState(true);
  const [debugInfo, setDebugInfo] = useState(null);
  const [directLoading, setDirectLoading] = useState(false);
  const { login, loading, error } = useAuth();
  const navigate = useNavigate();
  
  // Verificar se estamos na rede Radmin VPN
  useEffect(() => {
    const checkRadminVPN = async () => {
      try {
        // Tentar pingar o IP da rede Radmin VPN
        await axios.get('http://26.0.250.179:3002/test', { timeout: 2000 });
        console.log('Conexão com Radmin VPN detectada!');
        setDirectMode(true);
      } catch (error) {
        console.log('Não foi possível conectar via Radmin VPN, usando modo normal.');
      }
    };
    
    checkRadminVPN();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!username || !password) {
      return;
    }
    
    if (directMode) {
      await handleDirectLogin();
    } else {
      const success = await login(username, password);
      if (success) {
        navigate('/admin');
      }
    }
  };
  
  // Função para login direto via Radmin VPN ou proxy local
  const handleDirectLogin = async () => {
    try {
      setDirectLoading(true);
      
      // Determinar qual URL usar
      const loginUrl = useProxy
        ? 'http://localhost:3003/proxy/api/auth/login'
        : 'http://26.0.250.179:3002/api/auth/login';
      
      setDebugInfo(`Tentando login direto via ${useProxy ? 'proxy local' : 'Radmin VPN'}...`);
      
      // Fazer login usando a URL selecionada
      const response = await axios.post(loginUrl, {
        username,
        password
      });
      
      // Se o login for bem-sucedido, salvar o token e redirecionar
      if (response.data && response.data.token) {
        localStorage.setItem('token', response.data.token);
        axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`;
        setDebugInfo('Login direto bem-sucedido! Redirecionando...');
        setTimeout(() => navigate('/admin'), 1000);
        return true;
      }
    } catch (error) {
      console.error('Erro no login direto:', error);
      setDebugInfo(`Erro no login direto: ${error.message}. ${error.response?.data?.error || ''}`);
      
      // Tentar modo de depuração
      await handleDebugLogin();
      return false;
    } finally {
      setDirectLoading(false);
    }
  };
  
  // Função para depurar o login
  const handleDebugLogin = async () => {
    setDebugInfo('Iniciando diagnóstico de login...');
    const results = await testAuthDirectly(username, password);
    
    // Formatar os resultados para exibição
    const debugText = results.map(r => {
      return `URL: ${r.url}\nSucesso: ${r.success ? 'SIM' : 'NÃO'}\n${r.success ? 'Token: ' + r.data.token.substring(0, 15) + '...' : 'Erro: ' + (r.data?.error || r.error)}\n`;
    }).join('\n');
    
    setDebugInfo(debugText);
    
    // Se algum login for bem-sucedido, usar esse token
    const successResult = results.find(r => r.success);
    if (successResult) {
      localStorage.setItem('token', successResult.data.token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${successResult.data.token}`;
      setDebugInfo(debugText + '\nLogin bem-sucedido encontrado! Redirecionando...');
      setTimeout(() => navigate('/admin'), 2000);
      return true;
    }
    
    return false;
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h2>Área Administrativa</h2>
          <p>Floratta Cosméticos</p>
          {directMode && <span className="direct-mode-badge">Modo Direto (Radmin VPN)</span>}
        </div>
        
        {error && (
          <div className="login-error">
            {error}
          </div>
        )}
        
        {debugInfo && (
          <div className="debug-info">
            <h4>Informações de Diagnóstico:</h4>
            <pre>{debugInfo}</pre>
          </div>
        )}
        
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="username">Nome de usuário</label>
            <input
              type="text"
              id="username"
              name="username"
              autoComplete="username"
              autoFocus
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              disabled={loading}
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">Senha</label>
            <input
              type="password"
              id="password"
              name="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={loading}
              required
            />
          </div>
          
          <button
            type="submit"
            className="login-button"
            disabled={(loading || directLoading) || !username || !password}
          >
            {(loading || directLoading) ? 'Carregando...' : directMode ? 'Entrar (Modo Direto)' : 'Entrar'}
          </button>
          
          <div className="login-actions">
            <button 
              type="button" 
              className="debug-button"
              onClick={handleDebugLogin}
              disabled={loading || directLoading}
            >
              Diagnosticar Login
            </button>
            
            <div className="toggle-options">
              <label className="mode-toggle">
                <input 
                  type="checkbox" 
                  checked={directMode} 
                  onChange={(e) => setDirectMode(e.target.checked)}
                  disabled={loading || directLoading}
                />
                Modo Direto
              </label>
              
              {directMode && (
                <label className="mode-toggle">
                  <input 
                    type="checkbox" 
                    checked={useProxy} 
                    onChange={(e) => setUseProxy(e.target.checked)}
                    disabled={loading || directLoading}
                  />
                  Usar Proxy Local
                </label>
              )}
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
